 define('Facets.Fix', [
     'Facets.Translator.SortItems.Fix'
 ],
 function FacetsFix(

 ) {
     'use strict';

     return {};
 });

